module.exports = __webpack_public_path__ + "static/Kreo_Battleship_Mini_Movie-3cb8111c6a1229ccbd2f994695886f8a.jpg";